import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Namespaces za organizaciju prevoda
const namespaces = [
  'common',
  'header',
  'footer',
  'home',
  'about',
  'jobs',
  'store',
  'seo',
];

i18n
  // Učitavanje prevoda sa backend-a (lazy loading)
  .use(HttpBackend)
  // Detekcija jezika iz browser-a ili localStorage
  .use(LanguageDetector)
  // React integracija
  .use(initReactI18next)
  .init({
    // Default namespace
    defaultNS: 'common',
    // Svi namespace-ovi
    ns: namespaces,
    // Fallback jezik
    fallbackLng: 'sr',
    // Podržani jezici
    supportedLngs: ['sr', 'en'],
    // Koristi samo jezik bez regiona (sr-RS -> sr)
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    // Debug mode
    debug: false,
    // Inicijalizuj odmah (ne čekaj sve da se učita)
    initImmediate: true,
    
    // Backend konfiguracija za lazy loading
    backend: {
      // Putanja do translation fajlova (public folder se servira direktno)
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // Detekcija jezika
    detection: {
      // Redosled provere
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      // Ključ u localStorage
      lookupLocalStorage: 'i18nextLng',
      // Cache jezik u localStorage
      caches: ['localStorage'],
    },
    
    // Interpolacija
    interpolation: {
      escapeValue: false, // React već escape-uje
    },
    
    // React specificne opcije
    react: {
      useSuspense: false,
    },
  });

export default i18n;
